import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n            text-align: ", ";\n        "]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n    ", "\n    font-size: 16px;\n    color: #f0f8ff;\n    ", "\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    ", "\n    color: #69a0d3;\n    font-size: 28px;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    ", "\n    text-align: center;\n    color: #69a0d3;\n    font-size: 48px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    line-height: 1.6;\n    font-family: 'Source Code Pro', monospace;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
const baseTextStyles = css(_templateObject());
export const Title = styled.h1(_templateObject2(), baseTextStyles);
export const SubTitle = styled.h2(_templateObject3(), baseTextStyles);
export const Text = styled.p(_templateObject4(), baseTextStyles, p => p.align && css(_templateObject5(), p.align));